/* React Higher Order Component which fetches short course licenses for given id (short course hash must also be provided)
    Child (InnerComponent) will only render once short course licenses are successfully fetched.
    child will receive props: {
        licenses: PropTypes.object, // short course licenses keyed by token
        fatalError: PropTypes.object,
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    shortCourseHash: PropTypes.string.isRequired,
    forceRefreshOnMount: PropTypes.bool,
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    forceRefreshOnMount: false,
    hideLoadingIcon: false
};

export default function withShortCourseLicenseData(WrappedComponent) {
    class WithShortCourseLicenseData extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                licenses: ShortCourseStore.getState().courseLicensesByCourseHash[props.shortCourseHash],
                getActionId: null,
                fatalError: null
            }

            this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
        }

        componentDidMount() {
            if (!this.state.licenses) {
                const actionId = uuid.v4();
                this.setState({ getActionId: actionId }, () => {
                    ShortCourseActions.getLicensesForShortCourse(actionId, { shortCourseId: this.props.shortCourseId });
                });
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onShortCourseStoreChange(newState) {
            let updatedState = { licenses: newState.courseLicensesByCourseHash[this.props.shortCourseHash] };
            if (newState.action.id === this.state.getActionId) {
                updatedState = { ...updatedState, getActionId: null };
                if (!!newState.action.error) {
                    updatedState = { ...updatedState, fatalError: newState.action.error };
                }
            }

            this.setState({
                ...updatedState,
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace />;
            }

            if (!this.state.licenses) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    licenses={this.state.licenses}
                />
            );
        }
    }

    WithShortCourseLicenseData.propTypes = propTypes;
    WithShortCourseLicenseData.defaultProps = defaultProps;
    WithShortCourseLicenseData.displayName = `WithShortCourseLicenseData(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithShortCourseLicenseData;
}
